import { z } from "zod/v4";

export const stripeAccountResponseSchema = z.object({
	id: z.string(),
	stripe_account_id: z.string(),
	onboarding_complete: z.boolean(),
	charges_enabled: z.boolean(),
	payouts_enabled: z.boolean(),
	country: z.string(),
});

export const stripeConnectResponseSchema = z.object({
	account_id: z.string(),
	onboarding_url: z.string(),
});

export const stripeDashboardLinkResponseSchema = z.object({
	url: z.string(),
});

export const checkoutSessionResponseSchema = z.object({
	checkout_url: z.string(),
});

export const subscriptionStatusSchema = z.enum([
	"active",
	"past_due",
	"canceled",
	"unpaid",
	"incomplete",
]);

export const stripeProductResponseSchema = z.object({
	id: z.string(),
	membership_fee_id: z.string(),
	stripe_product_id: z.string(),
	stripe_price_id: z.string(),
});

export const subscriptionResponseSchema = z.object({
	id: z.string(),
	club_id: z.string(),
	member_id: z.string(),
	membership_fee_id: z.string(),
	stripe_subscription_id: z.string(),
	status: subscriptionStatusSchema,
	current_period_start: z.coerce.date().nullable().optional(),
	current_period_end: z.coerce.date().nullable().optional(),
	canceled_at: z.coerce.date().nullable().optional(),
	fee_name: z.string().optional(),
	member_name: z.string().optional(),
});

export const sepaSetupResponseSchema = z.object({
	setup_url: z.string(),
});

// Club self-serve platform plan (the club's OWN Club/Club Pro/Verband subscription).
export const planCheckoutResponseSchema = z.object({
	checkout_url: z.string(),
});

export const planPortalResponseSchema = z.object({
	portal_url: z.string(),
});

export type StripeAccountResponse = z.infer<typeof stripeAccountResponseSchema>;
export type StripeConnectResponse = z.infer<typeof stripeConnectResponseSchema>;
export type CheckoutSessionResponse = z.infer<typeof checkoutSessionResponseSchema>;
export type SubscriptionStatus = z.infer<typeof subscriptionStatusSchema>;
export type StripeProductResponse = z.infer<typeof stripeProductResponseSchema>;
export type SubscriptionResponse = z.infer<typeof subscriptionResponseSchema>;
export type SEPASetupResponse = z.infer<typeof sepaSetupResponseSchema>;
export type PlanCheckoutResponse = z.infer<typeof planCheckoutResponseSchema>;
export type PlanPortalResponse = z.infer<typeof planPortalResponseSchema>;
